import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import { useTranslation } from "../../contexts/TranslationContext";
import "../../assets/css/brand.css";
import "./Footer.css";

const Footer = () => {
  const { isRTL } = useTranslation();

  return (
    <footer className="site-footer" dir={isRTL ? "rtl" : "ltr"}>
      <div className="container site-footer__inner">
        <Link to="/" className="site-footer__brand">
          <img src={logo} alt="Padel Kingdom" />
        </Link>

        <nav className="site-footer__links">
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms &amp; Conditions</Link>
          <Link to="/cancellation-policy">Cancellation Policy</Link>
        </nav>

        <p className="site-footer__copy">
          © {new Date().getFullYear()} Padel Kingdom. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
